import * as React from 'react';
import { cn } from '@wayste/shadcn/lib/utils';
import * as LabelPrimitive from '@radix-ui/react-label';

function Label({ className, ...props }: React.ComponentProps<typeof LabelPrimitive.Root>) {
    return (
        <LabelPrimitive.Root
            data-slot="label"
            className={cn(
                'flex select-none items-center gap-2 text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50 group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50',
                className,
            )}
            {...props}
        />
    );
}

export { Label };
